import React from "react";
import { Card } from "react-bootstrap";
import FalconCardHeader from "../FalconCardHeader";

function CardDiv({ title, component, className }) {
  return (
    <Card className="overflow p-0 h-100">
      {title && <FalconCardHeader light title={title} titleTag="h6" />}
      <Card.Body className={`h-100 ${className}`}>{component}</Card.Body>
    </Card>
  );
}

export default CardDiv;
